/* ============================================================
   Pholoh Fit Builder.
   Pick one variant per category → live subtotal + projected bundle discount →
   "Add fit to cart" sends every selected variant in one /cart/add.js call and
   reuses Impulse's ajaxProduct:added to open + rebuild the cart drawer.
   The % is a projection; the real discount is an automatic discount set in
   Shopify admin to match the tiers.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-pfb]');
  if (!root) return;

  var tiers = [];
  try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) {}
  tiers.sort(function (a, b) { return a.min - b.min; });

  var bar = root.querySelector('[data-pfb-bar]');
  var countEl = root.querySelector('[data-pfb-count]');
  var totalEl = root.querySelector('[data-pfb-total]');
  var pctEl = root.querySelector('[data-pfb-pct]');
  var fillEl = root.querySelector('[data-pfb-fill]');
  var hintEl = root.querySelector('[data-pfb-hint]');
  var addBtn = root.querySelector('[data-pfb-add]');
  var cats = Array.prototype.slice.call(root.querySelectorAll('[data-pfb-cat]'));
  var selection = {}; // categoryIndex -> {id, price}

  function money(c) {
    /* PholohMoney first: theme.settings.moneyFormat is the SHOP format ("${{amount}}"),
       so it prints dollars at anyone paying in another currency. */
    if (window.PholohMoney) { return window.PholohMoney.format(c); }
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(c, theme.settings.moneyFormat);
    }
    return '$' + (c / 100).toFixed(2);
  }
  function bestTier(n) {
    var t = null;
    for (var i = 0; i < tiers.length; i++) { if (n >= tiers[i].min) t = tiers[i]; }
    return t;
  }

  function render() {
    var keys = Object.keys(selection);
    var n = keys.length;
    var sub = keys.reduce(function (s, k) { return s + selection[k].price; }, 0);
    bar.hidden = n < 1;
    addBtn.disabled = n < 1;

    countEl.textContent = n + (n === 1 ? ' item' : ' items');

    var t = bestTier(n);
    var off = t ? t.off : 0;

    // CTA price: crossed-out original + discounted price (or just the total before
    // any tier). Strip ".00" so the long THB amounts fit on one line.
    var short = function (c) { return money(c).replace('.00', ''); };
    if (off > 0) {
      totalEl.innerHTML = '<s>' + short(sub) + '</s>' + short(sub - Math.round(sub * off / 100));
    } else {
      totalEl.textContent = short(sub);
    }

    // discount % section above the CTA
    if (pctEl) {
      pctEl.textContent = off + '% off';
      pctEl.classList.toggle('is-zero', off === 0);
    }
    var maxMin = tiers.length ? tiers[tiers.length - 1].min : 4;
    var progress = Math.min(100, Math.round((n / maxMin) * 100));
    if (fillEl) fillEl.style.width = progress + '%';

    if (hintEl) {
      var next = null;
      for (var i = 0; i < tiers.length; i++) { if (n < tiers[i].min) { next = tiers[i]; break; } }
      if (next) {
        var need = next.min - n;
        hintEl.textContent = 'Add ' + need + ' more ' + (need === 1 ? 'piece' : 'pieces') + ' for ' + next.off + '% off';
      } else {
        hintEl.textContent = "You've unlocked the biggest discount";
      }
    }
  }

  root.addEventListener('click', function (e) {
    var sb = e.target.closest('.pfb__size');
    if (!sb || sb.disabled) return;
    var card = sb.closest('.pfb__card');
    var cat = sb.closest('[data-pfb-cat]');
    var ci = cats.indexOf(cat);
    var vid = sb.getAttribute('data-variant-id');

    if (selection[ci] && selection[ci].id === vid) {
      delete selection[ci];
      card.classList.remove('is-selected');
      sb.classList.remove('is-active');
    } else {
      cat.querySelectorAll('.pfb__card.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
      cat.querySelectorAll('.pfb__size.is-active').forEach(function (b) { b.classList.remove('is-active'); });
      selection[ci] = { id: vid, price: parseInt(sb.getAttribute('data-price'), 10) || 0 };
      card.classList.add('is-selected');
      sb.classList.add('is-active');
    }
    render();
  });

  addBtn.addEventListener('click', function () {
    var items = Object.keys(selection).map(function (k) { return { id: selection[k].id, quantity: 1 }; });
    if (!items.length) return;
    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data }, bubbles: true }));
      })
      .catch(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = false; });
  });

  render();
})();
